import * as React from 'react';
import is from 'is-lite';
import CloseButton from './CloseButton';
function FloaterContainer(props) {
    var content = props.content, footer = props.footer, onClick = props.onClick, open = props.open, positionWrapper = props.positionWrapper, showCloseButton = props.showCloseButton, styles = props.styles, title = props.title;
    var output = {
        content: React.isValidElement(content) ? (content) : (React.createElement("div", { className: "__floater__content", style: styles.content }, content)),
    };
    if (title) {
        output.title = React.isValidElement(title) ? (title) : (React.createElement("div", { className: "__floater__title", style: styles.title }, title));
    }
    if (footer) {
        output.footer = React.isValidElement(footer) ? (footer) : (React.createElement("div", { className: "__floater__footer", style: styles.footer }, footer));
    }
    if ((showCloseButton || positionWrapper) && !is.boolean(open)) {
        output.close = React.createElement(CloseButton, { onClick: onClick, styles: styles.close });
    }
    return (React.createElement("div", { className: "__floater__container", style: styles.container },
        output.close,
        output.title,
        output.content,
        output.footer));
}
export default FloaterContainer;
//# sourceMappingURL=Container.js.map